(() => {
  if(window.studioCountrySearchReady)return;window.studioCountrySearchReady=true;
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  document.addEventListener('input',event=>{
    if(!event.target.matches('[data-country-search]'))return;
    const panel=event.target.closest('.country-panel'),query=normalize(event.target.value);let count=0;
    panel.querySelectorAll('[data-country-choice]').forEach(row=>{row.hidden=!normalize(row.dataset.search).includes(query);if(!row.hidden)count++;});
    panel.querySelector('[data-country-empty]').hidden=count>0;
  });
  document.addEventListener('toggle',event=>{if(event.target.matches('.footer-country')&&event.target.open)document.querySelectorAll('.footer-country[open]').forEach(el=>{if(el!==event.target)el.open=false;});},true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const details=event.target.closest('.footer-country');if(details){details.open=false;details.querySelector('summary').focus();}}});
})();
